import CourseSchedulingDetailsFormModule from './containers/courseSchedulingDetailsFormModule'

export {default as CourseSchedulingDetailsFormModuleLayout} from './components/courseSchedulingDetailsFormModuleLayout'

export default CourseSchedulingDetailsFormModule
